import styled from 'styled-components';

export const CoverImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
